import { render } from "./Booking.vue?vue&type=template&id=5435b07c"
import script from "./Booking.vue?vue&type=script&lang=js"
export * from "./Booking.vue?vue&type=script&lang=js"

import exportComponent from "/Users/teguhsangra/Web/web_servio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__